import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
/*import {  ReactiveFormsModule } from '@angular/forms';
*/import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ToastrModule } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { FixedPluginModule} from './shared/fixedplugin/fixedplugin.module';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SharedMaterialModule } from './shared/shared-material.module';
import { LandingComponent } from './pages/landing/landing.component';
import { UserComponent } from './pages/user/user.component';
import { ClipboardModule } from 'ngx-clipboard';
import { CreatorComponent } from './pages/creator/creator.component';
/*import { LoaderComponent } from './shared/loader/loader.component';*/

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LandingComponent,
    UserComponent,
    CreatorComponent,
  ],
  imports: [
    ClipboardModule,
    NgxSpinnerModule,
    SharedMaterialModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes,{
      useHash: true
    }),
    SidebarModule,
    NavbarModule,
    ToastrModule.forRoot(),
    FooterModule,
    FixedPluginModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class AppModule { }
